import { ReactNode } from 'react';
import useUrlFlickerDetection from '../hooks/useUrlFlickerDetection';

// wrapper component to wrap various observability hooks underneath the browser router
export default function ObservabilityWrapper({ children }: { children: ReactNode }) {
  useUrlFlickerDetection();
  return children as React.ReactElement;
}
